import { cn } from "@lib/cn";
import { IconInfoCircle } from "@tabler/icons-react";

export const EmptyStateMessage = ({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-flex-auto tw-w-[291px] tw-mx-auto",
        className,
      )}
    >
      <IconInfoCircle className="tw-size-6 tw-text-[#610CFF]" />
      <div className="tw-flex tw-flex-col tw-items-center">
        <p className="tw-font-sans tw-text-sm tw-font-semibold tw-text-blue tw-text-center">
          {title}
        </p>
        <p className="tw-font-sans tw-text-xs tw-font-normal tw-text-blue-500 tw-text-center tw-mt-2">
          {description}
        </p>
      </div>
    </div>
  );
};
